export default "/images/Privaposts-price-tag-icon.png?b0b5ba60e59ae50620392b1f38623c8c";